import { Box } from '@mui/material';
import { Outlet, useRouter } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { useCurrentUserQuery } from 'entities/user';
import { Routes } from 'shared/routes';
import Loader from 'shared/ui/Loader';

import Header from './Header';

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    flexGrow: 1,
  },
} as const;

const AuthLayout = () => {
  const { data: currentUser, isLoading } = useCurrentUserQuery();
  const router = useRouter();

  if (isLoading) {
    return <Loader />;
  }

  if (!currentUser) {
    return router.navigate({ to: Routes.frontend.loginPath });
  }

  return (
    <Box sx={styles.root}>
      <Header />
      <Box component="main" sx={styles.main}>
        <Outlet />
        <TanStackRouterDevtools />
      </Box>
    </Box>
  );
};

export { AuthLayout };
